import { render, staticRenderFns } from "./BrisanjePodataka.vue?vue&type=template&id=0294563d&scoped=true&"
import script from "./BrisanjePodataka.vue?vue&type=script&lang=ts&"
export * from "./BrisanjePodataka.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0294563d",
  null
  
)

export default component.exports